<template>
    <academic>
        <card-header :title="'Course Year: '+courseyear.title+' - '+courseyear.course.title"/>
        <div class="p-6 bg-white border-b border-gray-200 shadow-sm sm:rounded-lg">
            <loading :showLoading="form.processing"/>
            <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                <p class="text-lg font-medium mb-4">Add Course Semester</p>
                <form @submit.prevent="submitForm">
                    <div class="mb-4">
                        <div v-for="(sem,index) in form.semesters" :key="index">
                            <div class="grid grid-cols-8 gap-4 mb-4">
                                <div class="col-span-3 sm:col-span-3">
                                    <!-- <breeze-label :value="'Semester'"/>
                                    <select-list required v-model="form.semesters[index].semester" :options="semesters" :label="['title']" class="w-full"/>
                                    <breeze-input-error :message="form.errors?form.errors.duration:''" /> -->

                                    <FormMultiselect
                                        required
                                        label="Semester"
                                        :options="semesters"
                                        track-key="id"
                                        label-key="title"
                                        :object="true"
                                        v-model="form.semesters[index].semester"
                                        :placeholder="'Select Semester Type'"
                                        :error="form.errors.semesters"
                                    />

                                </div>
                                <div class="col-span-3 sm:col-span-3">
                                    <!-- <breeze-label :value="'Subject'"/> -->
                                    <!-- <select-list required v-model="form.semesters[index].subject" :options="subjects" :label="['title']" class="w-full"/>
                                    <breeze-input-error :message="form.errors?form.errors.course:''" /> -->
                                    <FormMultiselect
                                        required
                                        label="Subject"
                                        :options="subjects"
                                        track-key="id"
                                        label-key="title"
                                        :object="true"
                                        v-model="form.semesters[index].subject"
                                        :placeholder="'Select Subject'"
                                        :error="form.errors.course"
                                    />

                                </div>
                                <div class="col-span-1 sm:col-span-2">
                                    <breeze-label :value="'Status'"/>
                                    <breeze-checkbox v-model="form.semesters[index].status"
                                                     :checked="form.semesters[index].status"/>
                                    <breeze-input-error :message="form.errors?form.errors.status:''"/>
                                </div>
                                <div class="  col-span-1">
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                         class="h-6 w-6 text-red-500 justify-self-center cursor-pointer"
                                         viewBox="0 0 20 20"
                                         fill="currentColor"
                                         @click="form.semesters.splice(index,1)">
                                        <path fill-rule="evenodd"
                                              d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                              clip-rule="evenodd"
                                        />
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <breeze-button @click="addField" :type="'button'">Add</breeze-button>
                    </div>
                    <button-link :href="route('academic.courseyear.list')" class="bg-red-500 mr-4 hover:bg-red-400">
                        Cancel
                    </button-link>
                    <breeze-button :disabled="form.processing">Save</breeze-button>
                    <exception/>
                </form>
            </div>
        </div>
    </academic>
</template>

<script>
import Academic from '@/Pages/Academic/Academic'
import BreezeTable from '@/Components/Table'
import BreezeInput from '@/Components/Input'
import BreezeLabel from '@/Components/Label'
import BreezeButton from '@/Components/Button'
import BreezeCheckbox from '@/Components/Checkbox'
import InputCheckbox from '@/Components/InputCheckbox'
import BreezeInputError from '@/Components/InputError'
import ButtonLink from '@/Components/ButtonLink'
import SelectList from '@/Components/SelectList'
import Exception from '@/Components/Exception'
import {useForm} from '@inertiajs/inertia-vue3'
import Loading from '@/Components/Loading'
import CardHeader from '@/Components/CardHeader'
import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";

export default {
    components: {
        FormMultiselect,
        Academic,
        BreezeTable,
        ButtonLink,
        BreezeInput,
        BreezeCheckbox,
        BreezeLabel,
        BreezeInputError,
        BreezeButton,
        Exception,
        InputCheckbox,
        Loading,
        SelectList,
        CardHeader
    },
    props: ['semesters', 'subjects', 'courseyear'],
    data() {
        return {
            form: useForm({
                semesters: [],
            }),
        }
    },
    methods: {
        submitForm() {
            this.form.post(route('academic.courseyear.semester.store', this.courseyear.id), {
                preserveScroll: true,
                onSuccess: () => this.form.reset(),
            });
        },
        addField() {
            this.form.semesters.push({semester: '', course: '', status: true});
        },

    },
}
</script>
